import React, { useState } from 'react';
import useMaintenanceBreakData from './Services/useMaintenanceBreakData.Hook';

const MaintenanceBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true);
  const { data: maintenanceBreakData, loading, error } = useMaintenanceBreakData();

  console.log("Maintenance break data:", maintenanceBreakData);
  console.log("Loading:", loading);
  console.log("Error:", error);

  // Nie renderuj podczas ładowania, błędu, braku danych lub gdy banner jest ukryty
  if (loading || error || !maintenanceBreakData || !isVisible) {
    return null;
  }

  const containerStyle: React.CSSProperties = {
    position: 'relative',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 9999,
    backgroundColor: '#4668fd',
    color: 'white',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    fontFamily: 'system-ui, -apple-system, sans-serif',
    fontSize: '14px',
    lineHeight: '1.4'
  };

  const innerContainerStyle: React.CSSProperties = {
    maxWidth: '1440px',
    margin: '0 auto',
    padding: '12px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px'
  };

  const leftSectionStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flex: '1',
    minWidth: 0
  };

  const iconStyle: React.CSSProperties = {
    width: '24px',
    height: '24px',
    filter: 'invert(1)',
    flexShrink: 0
  };

  const contentStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    flex: '1',
    minWidth: 0
  };

  const titleStyle: React.CSSProperties = {
    fontWeight: 600,
    fontSize: '15px',
    margin: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  };

  const detailsStyle: React.CSSProperties = {
    fontSize: '13px',
    opacity: 0.9,
    margin: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  };

  const rightSectionStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexShrink: 0
  };

  const durationStyle: React.CSSProperties = {
    fontSize: '12px',
    opacity: 0.9,
    whiteSpace: 'nowrap'
  };

  const closeButtonStyle: React.CSSProperties = {
    background: 'rgba(255, 255, 255, 0.1)',
    border: 'none',
    borderRadius: '50%',
    width: '32px',
    height: '32px',
    color: 'white',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s',
    flexShrink: 0
  };

  const progressBarStyle: React.CSSProperties = {
    height: '3px',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    position: 'relative',
    overflow: 'hidden'
  };

  const progressBarInnerStyle: React.CSSProperties = {
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
    animation: 'pulse 2s infinite'
  };

  const isMobile = typeof window !== 'undefined' && window.innerWidth < 640;

  return (
    <>
      <style>
        {`
          @keyframes pulse {
            0%, 100% { opacity: 0.4; }
            50% { opacity: 0.8; }
          }
        `}
      </style>
      <div style={containerStyle}>
        <div style={innerContainerStyle}>
          <div style={leftSectionStyle}>
            <img 
              src="https://cdnjs.cloudflare.com/ajax/libs/simple-icons/9.0.0/maintenance.svg" 
              alt="Maintenance"
              style={iconStyle}
              onError={(e) => {
                const img = e.currentTarget as HTMLImageElement;
                img.style.display = 'none';
                const emoji = img.nextElementSibling as HTMLSpanElement;
                if (emoji) {emoji.style.display = 'inline'};
              }}
            />
            <span style={{...iconStyle, display: 'none', fontSize: '24px', filter: 'none'}}>🔧</span>
            
            <div style={contentStyle}>
              <div style={titleStyle}>
                {maintenanceBreakData?.title ? `⚠️ ${maintenanceBreakData?.title}` : ''} 
              </div>
              <div style={detailsStyle}>
                {maintenanceBreakData?.content}
                {isMobile && ` • Czas trwania: ${maintenanceBreakData?.duration}`}
              </div>
            </div>
          </div>

          <div style={rightSectionStyle}>
            {!isMobile && (
              <div style={durationStyle}>
                Czas trwania: {maintenanceBreakData?.duration}
              </div>
            )}
            
            <button
              onClick={() => setIsVisible(false)}
              style={closeButtonStyle}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
              }}
              aria-label="Zamknij powiadomienie"
            >
              <svg 
                width="16" 
                height="16" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
                style={{pointerEvents: 'none'}}
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M6 18L18 6M6 6l12 12" 
                />
              </svg>
            </button>
          </div>
        </div>
        
        <div style={progressBarStyle}>
          <div style={progressBarInnerStyle} />
        </div>
      </div>
    </>
  );
};

export default MaintenanceBanner;


// WEBPACK FOOTER //
// ./src/components/MaintenanceBanner/MaintenanceBanner.Component.tsx